import React from 'react'

const Detail = () => {

    const imageProduct = [
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_ANGLE_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WDM-Lifestyle-PDP-Female-1_c6cefd60-c0bb-4c21-b152-345f92a7622c.jpg?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_LEFT_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_PAIR_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_HEEL_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_HEEL_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_BOTTOM_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.png?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_DETAIL_SIDE_ANGLE_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.jpg?v=1604598983',
        'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_1000,f_auto,q_auto,b_rgb:f5f5f5/https://cdn.shopify.com/s/files/1/1104/4168/products/WZ1MMET_SHOE_DETAIL_HEEL_ANGLE_GLOBAL_MENS_WOOL_DASHER_MIZZLE_LOW_METEORITE_GREY.jpg?v=1604598983',
    ];

    const colors = [
        ["#585c60", "#e2e2da"],
        ["#353946", "#e2e2da"],
        ["#28282c", "#434345"],
        ["#9d957a", "#e2e2da"],
        ["#e7e5e2", "#bfbab5"],
        ["#585c60", "#e2e2da"],
    ];

    const sizes = [
        '5',
        '5.5',
        '6',
        '6.5',
        '7',
        '7.5',
        '8',
        '8.5',
        '9',
        '9.5',
        '10',
        '10.5',
        '11',
    ]

    return (
        <div>
            detail product
        </div>
    )
}

export default Detail
